"use client";

import React, { memo, useCallback } from "react";
import {
  Box,
  Grid,
  Heading,
  Text,
  Badge,
  BoxProps,
} from "@chakra-ui/react";
import { formatDate } from "../../utils/timeUtils";

interface Meeting {
  date: string;
  pendingActions: unknown[];
}

interface EngagementOverviewProps extends BoxProps {
  filteredMeetings?: Meeting[];
}

const EngagementOverview: React.FC<EngagementOverviewProps> = ({
  filteredMeetings = [],
  ...boxProps
}) => {
  const totalMeetings = filteredMeetings.length;
  const lastMeeting = filteredMeetings[0]?.date ?? "N/A";
  const pendingActions = filteredMeetings[0]?.pendingActions?.length ?? 0;

  return (
    <Box
      overflow="hidden"
      bg="white"
      p={6}
      borderRadius="md"
      borderWidth="1px"
      borderColor="gray.200"
      {...boxProps}
    >
      <Heading as="h2" size="md" fontWeight="semibold" mb={6}>
        Engagement Overview
      </Heading>
      
      <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            Total Meetings
          </Text>
          <Text fontSize="xl" color="gray.800" fontWeight="semibold" mt={2}>
            {totalMeetings}
          </Text>
        </Box>
        
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            Last Meeting
          </Text>
          <Text fontSize="xl" color="gray.800" fontWeight="semibold" mt={2}>
            {formatDate(lastMeeting)}
          </Text>
        </Box>
        
        {/* <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            Pending Actions
          </Text>
          <Text fontSize="xl" color="gray.800" fontWeight="semibold" mt={2}>
            {pendingActions}
          </Text>
        </Box> */}
        
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="medium">
            Stage
          </Text>
          <Badge
            bg="blue.100"
            color="blue.700"
            px={2}
            py={1}
            borderRadius="sm"
            fontWeight="medium"
            mt={2}
          >
            ACTIVE
          </Badge>
        </Box>
      </Grid>
    </Box>
  );
};

export default memo(EngagementOverview);